export default "__VITE_ASSET__6e51536e__"